module.exports = __webpack_public_path__ + "static/img/bgBetask.15ee80c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgBetask.jpeg
// module id = vlW1
// module chunks = 1